import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';

import { MaePlantillaService } from 'src/app/service/mae-plantilla.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';

import { MaePlantillaM,MaePlantillaE } from 'src/app/model/mae-plantilla-bean';

import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { AuditoriaBeanM } from 'src/app/model/auditoria_bean';

import { saveAs } from 'file-saver';

import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';
import { MatDialog } from "@angular/material/dialog";
import { EstadoDml } from 'src/app/model/estadoDml';
import { error } from 'console';

@Component({
  selector: 'app-dml-plantilla',
  templateUrl: './dml-plantilla.component.html',
  styleUrls: ['./dml-plantilla.component.scss']
})
export class DmlPlantillaComponent implements OnInit {

  //variables enviado desde el padre
  id:String;
  x_titulo:String;
  x_proceso:String;

  //documento
  maePlantillaE = new MaePlantillaE();
  listC_tipo_convenio = new Array<Mae_tabla_E>();
  listC_periodo = new Array<Mae_tabla_E>();
  listEstado= new Array<Mae_tabla_E>();

  //Documentos / archivos
  modalRefArchivosDml: MDBModalRef;

  //archivo
  x_file:File=null;
  @ViewChild('labelArchivo')
  labelArchivo: ElementRef;

  seactualiza:boolean;
  esupdate:boolean;

  estadovisible:boolean = false;


  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();

  estadoDml = new EstadoDml();

  constructor(
    public  modalRefConvenioDml: MDBModalRef,
    private maePlantillaService:MaePlantillaService,
    private globalVariablesService:GlobalVariablesService,
    private detArchivoService:DetArchivoService,
    private maeTablaService:MaeTablaService,
    private utilitarioService:UtilitarioService,
    private modalService: MDBModalService,
    private dialogo: MatDialog,
  ) { }

  ngOnInit(): void {

    this.cargarDatoInicial(this.x_proceso);
  }

  cargarDatoInicial(dml:String){

    this.utilitarioService.loading = true;

    this.maePlantillaE.c_estado=0;

    const cargarEstado = this.maeTablaService.getList("ESTADO_REGISTRO").toPromise()
    .then(result => {
      this.listEstado = result;
    });


    if (dml=='I'){
      //carga los promesas culminadas para asignar los datos a las variables
      Promise.all([cargarEstado])
      .then(response => {
        this.utilitarioService.loading = false;
      })
      .catch(error => console.log(`Error in executing ${error}`));
    }

    if (dml=='U'){

      //carga los promesas culminadas para asignar los datos a las variables
      Promise.all([cargarEstado])
      .then(response => {

        let cargarMaeDocumento = this.maePlantillaService.get(this.id.toString()).toPromise()
        .then(result => {
          var datePipe = new DatePipe("en-US");
          this.utilitarioService.loading = false;
          this.maePlantillaE = result[0];
        });

      })
      .catch(error => console.log(`Error in executing ${error}`));
    }

  }

  async onGrabar(){

    console.log(this.maePlantillaE);
    if (this.validarFormulario()==false){
      return false;
    }

    this.utilitarioService.loading=true;
    if(this.seactualiza)//si se sube archivo
    {
      let formData = new FormData;

      formData.append("file",this.x_file);
      this.detArchivoService.upload(formData).subscribe( (response_dml_bean : Response_dml_bean) => {

        console.log(response_dml_bean);
        this.maePlantillaE.x_uid = response_dml_bean.codigoRegistroBD;
        this.maePlantillaE.x_archivo_ext = response_dml_bean.mensaje;
        //se registra o actualiza usuario
        this.GuardarPlantilla()

      },
      error=>{
        this.utilitarioService.toastrError("Hubo un error al guardar el archivo." + error.error.messages.toString());
        this.utilitarioService.loading=false;
      });
    }
    else
      this.GuardarPlantilla()
  }

  GuardarPlantilla(){

    let auditoriaBeanM = new AuditoriaBeanM();
    auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio(this.x_proceso);
    this.maePlantillaE.auditoriaBeanM = auditoriaBeanM;

    if(this.x_proceso=='I')
      this.maePlantillaService.insert(this.maePlantillaE).subscribe((response_dml_bean:Response_dml_bean)=>{

        this.utilitarioService.loading=false;
        if (response_dml_bean.codigoRespuestaServicio=="1"){
          this.action.next(response_dml_bean);
          this.onClosemodal();
        }
      },
      error=>{
        this.utilitarioService.loading=false;
        console.log(error);
        this.utilitarioService.toastrError(error.error.messages.toString());
      });
      else
      this.maePlantillaService.update(this.maePlantillaE).subscribe((response_dml_bean:Response_dml_bean)=>{

        this.utilitarioService.loading=false;
        if (response_dml_bean.codigoRespuestaServicio=="1"){
          this.action.next(response_dml_bean);
          this.onClosemodal();
        }
      },
      error=>{
        this.utilitarioService.loading=false;
        console.log("error en servicio");
        this.utilitarioService.toastrError(error.error.messages.toString());
      });




  }


  onClosemodal(){
    this.modalRefConvenioDml.hide();
  }

  validarFormulario() : Boolean{

    if (this.maePlantillaE.x_nombre=="" || this.maePlantillaE.x_nombre==null){
      this.utilitarioService.toastrError("Ingrese el nombre de la plantilla.");
      return false;
    }

    if (this.maePlantillaE.x_descripcion =="" || this.maePlantillaE.x_descripcion==null){
      this.utilitarioService.toastrError("Ingrese la descripcion de la plantilla.");
      return false;
    }
    if (this.maePlantillaE.c_estado==0 || this.maePlantillaE.c_estado==null){
      this.utilitarioService.toastrError("Seleccione el estado.");
      return false;
    }

    if(this.seactualiza)
    {
      if (this.x_file==null){
        this.utilitarioService.toastrError("Seleccione un archivo.");
        return false;
      }
      if (this.x_file.size<=0){
        this.utilitarioService.toastrError("Seleccione un archivo.");
        return false;
      }
    }

    //valida tipo de comprobante
    return true;

  }
  onFileChange(files: FileList){

    this.labelArchivo.nativeElement.innerText = Array.from(files)
      .map(f => f.name)
      .join(', ');

    this.x_file = files.item(0);
    console.log(files.item(0));

  }

  onDescargarArchivo(){
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(this.maePlantillaE.x_uid.toString()).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,this.maePlantillaE.x_nombre.toString() + this.maePlantillaE.x_archivo_ext.toString());
    });

  }


  fc_ValNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      return false;
      event.preventDefault();
    }
    return true;
  }

  dateFormat(cadena:String, tipo:String) {

    if (tipo=="1"){

      var arrayDeCadenas = cadena.split("-");
      console.log(arrayDeCadenas);
      if (arrayDeCadenas.length>1){
        return  arrayDeCadenas[2] + '/' + arrayDeCadenas[1] + '/' + arrayDeCadenas[0];
      }else{
        return cadena;
      }

    }else{

      var arrayDeCadenas = cadena.split("/");
      console.log(arrayDeCadenas);
      if (arrayDeCadenas.length>1){
        return  arrayDeCadenas[2] + '-' + arrayDeCadenas[1] + '-' + arrayDeCadenas[0];
      }else{
        return cadena;
      }

    }

  }
  onMostrarActualizar(semuestr:boolean){

    const limit = 0 as Number;
    if(this.maePlantillaE.c_plantilla>limit)
    if(semuestr)
    {
      this.seactualiza=true;
    }
    else
    {
      this.seactualiza=false;
      this.x_file = null;
    }
    else{
      this.utilitarioService.toastrWarning("No puede actualizar esta esta plantilla.");
    }
  }


  ngAfterViewInit() {

  }
}
